import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login'
import Dashboard from '@/pages/dashboard'
import Project from '@/pages/project'
import Match from '@/pages/match'
import SearchAsset from '@/pages/searchAsset'
import { store } from '@/store/store'
var VueCookie = require('vue-cookie')

Vue.use(Router)
let requestedPage = null

async function securityGuard (to, from, next) {
    let tokenId = to.query.tokenid || undefined
    let tokenValue = to.query.tokenvalue || undefined

    if (to.name !== 'login' && from.name === null) {
        try {
            const authenticated = await store.dispatch('ping', {tokenId: tokenId, tokenValue: tokenValue})
            if (authenticated) {
                if (store.getters.userInfo.userId === null) {
                    const response = await store.dispatch('getCurrentUserInfo')
                    if (response) {
                        await store.dispatch('getAllCodeLists')
                        if (store.getters.getRegnskabList().length === 0) {
                            await store.dispatch('getRegnskabList')
                        }
                        if (store.getters.getSelectedRegnskab === null) {
                            const selectedRegnskab = VueCookie.get('selectedRegnskab')
                            if (selectedRegnskab) {
                                await store.dispatch('setSelectedRegnskab', selectedRegnskab)
                                if (store.getters.getReportBalanceList.length === 0) {
                                    await store.dispatch('setReportBalanceList')
                                }
                                next()
                            } else {
                                next({name: 'login'})
                            }
                        } else {
                            next()
                        }
                    } else {
                        requestedPage = {name: to.name, params: to.params, done: false}
                        next({name: 'login'})
                    }
                } else if (requestedPage !== null && !requestedPage.done) {
                    requestedPage.done = true
                    next(requestedPage)
                } else {
                    next()
                }
            } else {
                requestedPage = {name: to.name, params: to.params, done: false}
                next({name: 'login'})
            }
        } catch (err) {
            console.log('securityGuard error', err)
        }
    } else if (requestedPage !== null && !requestedPage.done) {
        requestedPage.done = true
        next(requestedPage)
    } else {
        next()
    }
}

// async function securityGuard (to, from, next) {
//     if (to.name !== 'login' && from.name === null) {
//         if (store.getters.userInfo.userId === null) {
//             try {
//                 const response = await store.dispatch('getCurrentUserInfo')
//                 if (response) {
//                     await store.dispatch('getAllCodeLists')
//                     if (store.getters.getRegnskabList().length === 0) {
//                         await store.dispatch('getRegnskabList')
//                     }
//                     if (store.getters.getSelectedRegnskab === null) {
//                         const selectedRegnskab = VueCookie.get('selectedRegnskab')
//                         if (selectedRegnskab) {
//                             await store.dispatch('setSelectedRegnskab', selectedRegnskab)
//                             requestedPage = {name: to.name, params: to.params}
//                         } else {
//                             requestedPage = {name: 'login'}
//                         }
//                         if (store.getters.getReportBalanceList.length === 0) {
//                             await store.dispatch('setReportBalanceList')
//                         }
//                     } else {
//                         requestedPage = {name: to.name, params: to.params}
//                     }
//                 }
//             } catch (err) {
//                 next({name: 'login'})
//             }
//         } else {
//             next()
//         }

//         if (!requestedPage) {
//             requestedPage = {name: 'login'}
//         }

//         next(requestedPage)
//     } else {
//         next()
//     }
// }

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/forside',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: securityGuard
        },
        {
            path: '/match/:id',
            name: 'matchid',
            component: Match,
            params: {
                id: ''
            },
            beforeEnter: securityGuard
        },
        {
            path: '/projekt/:id',
            name: 'projectid',
            component: Project,
            params: {
                id: ''
            },
            beforeEnter: securityGuard
        },
        {
            path: '/aktiver',
            name: 'searchAsset',
            component: SearchAsset,
            beforeEnter: securityGuard
        },
        {
            path: '*',
            redirect: '/',
            beforeEnter: securityGuard
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js